import { useQuery } from 'react-query';

import { getTrapDetailHeatMapSRBMChart } from 'api/traps/Trap/getTrapDetailHeatMapSRBMChart';

export const useGetTrapDetailHeatMapSRBMChartData = (
  slug: string,
  start_datetime: string,
  end_datetime: string,
  isCompare?: boolean,
  isSRBM: boolean = true,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['TrapDetailHeatMapSRBMChartData', start_datetime, end_datetime, slug, isCompare],
    () => getTrapDetailHeatMapSRBMChart(slug, start_datetime, end_datetime),
    {
      refetchOnWindowFocus: false,
      enabled: isSRBM,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetTrapDetailHeatMapSRBMChartData;
